import CreateWork from './create';

export default function EditWork() {
  return CreateWork();
}
